import { CardAnalytics } from '../cards';
import { UserBase, UserFeedback } from '../user';
import { createEventTracker } from '../util';
import {
  AnalyzeWithConversions,
  CardAdded,
  CardDeleted,
  DashboardBase,
  DashboardViewed,
  DashboardOverlayChange,
  DashboardOverlayToggle,
  DashboardOverlaySave,
  OwnersTransferred,
} from './types';

export const trackSubmitDashboardFeedback = createEventTracker<UserFeedback>(
  'Submitted Dashboards Feedback',
);
export const trackDashboardCreated =
  createEventTracker<Omit<DashboardBase, 'num_cards_int'>>('Dashboard Created');
export const trackDashboardDeleted = createEventTracker<DashboardBase>('Dashboard Deleted');
export const trackCardSaved = createEventTracker<CardAdded>('Dashboard Card Saved');
export const trackCardUpdated = createEventTracker<CardAnalytics & UserBase>(
  'Dashboard Card Updated',
);
export const trackCardDeleted = createEventTracker<CardDeleted>('Dashboard Card Deleted');

// Track a dashboard is loaded
export const trackDashboardViewed = createEventTracker<DashboardViewed>('Dashboard Viewed');
export const trackCardsArranged = createEventTracker<DashboardBase>('Dashboard Cards Arranged');
export const trackAnalyzeWithConversions = createEventTracker<AnalyzeWithConversions>(
  'Dashboard Analyze With Conversions',
);

// Track dashboard overlays
export const trackOverlayCleared = createEventTracker<DashboardBase>('Dashboard Overlay Cleared');
export const trackOverlayReverted = createEventTracker<DashboardBase>('Dashboard Overlay Reverted');
export const trackOverlayChange = createEventTracker<DashboardOverlayChange>(
  'Dashboard Overlay Changed',
);
export const trackOverlayFilterToggled = createEventTracker<DashboardOverlayToggle>(
  'Dashboard Overlay Filter Toggled',
);
export const trackOverlaySaved =
  createEventTracker<DashboardOverlaySave>('Dashboard Overlay Saved');

export const trackOwnerTransfer = createEventTracker<OwnersTransferred>('Owners Modified');
